import { useEffect, useState } from "react";

import {
  DateModal,
  DealerDashboardFilters,
  monthNames,
} from "@Pages/DealersDashboard/DealersDashboard";

import styles from "../../DealersDashboard/DealersDashboard.module.scss";

const Filters = ({
  setFilters,
  filters,
}: {
  setFilters: React.Dispatch<React.SetStateAction<DealerDashboardFilters>>;
  filters: DealerDashboardFilters;
}) => {
  const [currentModal, setCurrentModal] = useState<"date" | "location" | null>(
    null
  );
  //click outside to close
  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest(`.${styles.filtersButtons}`)) {
      setCurrentModal(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.filters}>
      <div className={styles.filtersButtons}>
        Filters:
        <button
          onClick={() =>
            currentModal == "date"
              ? setCurrentModal(null)
              : setCurrentModal("date")
          }
        >
          {filters.year || "Year"} |{" "}
          {filters.month ? monthNames[filters.month - 1] : "Month"}
        </button>
        {currentModal === "date" ? (
          <DateModal
            setFilters={setFilters}
            filters={filters}
            setCurrentModal={setCurrentModal}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Filters;
